import WPSResource from '../../../WPS.resource';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { ROOT_REDUCER_KEYS, WORKSPACE_SG_ACTION_KEYS } from '../../workspaceSettingsReducer';
export const defaultReducerState = getDefaultAsyncWrapperObj();
const workspaceSecurityGroupsDeletePrefix = 'WorkspaceSecurityGroupsDelete';
const workspaceSecurityGroupsDeleteEpicReducerArg = {
    actionPrefix: workspaceSecurityGroupsDeletePrefix,
    reduxKeyNested: (inputPayload) => [
        ROOT_REDUCER_KEYS.WORKSPACE_SG,
        WORKSPACE_SG_ACTION_KEYS.DELETE,
    ],
    loadResource: (request) => {
        return WPSResource.deleteWorkspaceSecurityGroup(request.workspaceId, request.securityGroupId, request.experimentRole);
    },
    onCompleteSuccess: (resourcesResult) => resourcesResult,
};
export const workspaceSecurityGroupsDeleteEpicReducer = loadResourcesUtils(workspaceSecurityGroupsDeleteEpicReducerArg);

//# sourceMappingURL=DeleteWorkspaceSecurityGroups.ducks.js.map
